export default __webpack_public_path__ + "static/media/24_gangsta.c9602bc8.png";